// Configuration for room fields
export const roomFields = [
  {
    id: 'bedroomDoubleEnSuite',
    name: 'bedroomDoubleEnSuite',
    labelId: 'DreamHomePageForm.DesignBriefFormFields.homeSpecification.bedroomDoubleEnSuiteLabel',
    placeholderId:
      'DreamHomePageForm.DesignBriefFormFields.homeSpecification.bedroomDoubleEnSuitePlaceholder',
    defaultLabel: 'Bedroom double with en-suite',
    defaultPlaceholder: '0',
  },
  {
    id: 'bedroomDouble',
    name: 'bedroomDouble',
    labelId: 'DreamHomePageForm.DesignBriefFormFields.homeSpecification.bedroomDoubleLabel',
    placeholderId:
      'DreamHomePageForm.DesignBriefFormFields.homeSpecification.bedroomDoublePlaceholder',
    defaultLabel: 'Bedroom double',
    defaultPlaceholder: '0',
  },
  {
    id: 'bedroomSingle',
    name: 'bedroomSingle',
    labelId: 'DreamHomePageForm.DesignBriefFormFields.homeSpecification.bedroomSingleLabel',
    placeholderId:
      'DreamHomePageForm.DesignBriefFormFields.homeSpecification.bedroomSinglePlaceholder',
    defaultLabel: 'Bedroom single',
    defaultPlaceholder: '0',
  },
  {
    id: 'kitchen',
    name: 'kitchen',
    labelId: 'DreamHomePageForm.DesignBriefFormFields.homeSpecification.kitchenLabel',
    placeholderId: 'DreamHomePageForm.DesignBriefFormFields.homeSpecification.kitchenPlaceholder',
    defaultLabel: 'Kitchen',
    defaultPlaceholder: '0',
  },
  {
    id: 'diningArea',
    name: 'diningArea',
    labelId: 'DreamHomePageForm.DesignBriefFormFields.homeSpecification.diningAreaLabel',
    placeholderId:
      'DreamHomePageForm.DesignBriefFormFields.homeSpecification.diningAreaPlaceholder',
    defaultLabel: 'Dining area/room',
    defaultPlaceholder: '0',
  },
  {
    id: 'livingRoom',
    name: 'livingRoom',
    labelId: 'DreamHomePageForm.DesignBriefFormFields.homeSpecification.livingRoomLabel',
    placeholderId:
      'DreamHomePageForm.DesignBriefFormFields.homeSpecification.livingRoomPlaceholder',
    defaultLabel: 'Living room',
    defaultPlaceholder: '0',
  },
  {
    id: 'studyOffice',
    name: 'studyOffice',
    labelId: 'DreamHomePageForm.DesignBriefFormFields.homeSpecification.studyOfficeLabel',
    placeholderId:
      'DreamHomePageForm.DesignBriefFormFields.homeSpecification.studyOfficePlaceholder',
    defaultLabel: 'Study/Office',
    defaultPlaceholder: '0',
  },
  {
    id: 'utilityRoom',
    name: 'utilityRoom',
    labelId: 'DreamHomePageForm.DesignBriefFormFields.homeSpecification.utilityRoomLabel',
    placeholderId:
      'DreamHomePageForm.DesignBriefFormFields.homeSpecification.utilityRoomPlaceholder',
    defaultLabel: 'Utility room',
    defaultPlaceholder: '0',
  },
  {
    id: 'bathroom',
    name: 'bathroom',
    labelId: 'DreamHomePageForm.DesignBriefFormFields.homeSpecification.bathroomLabel',
    placeholderId: 'DreamHomePageForm.DesignBriefFormFields.homeSpecification.bathroomPlaceholder',
    defaultLabel: 'Bathroom',
    defaultPlaceholder: '0',
  },
  {
    id: 'wc',
    name: 'wc',
    labelId: 'DreamHomePageForm.DesignBriefFormFields.homeSpecification.wcLabel',
    placeholderId: 'DreamHomePageForm.DesignBriefFormFields.homeSpecification.wcPlaceholder',
    defaultLabel: 'Cloakroom/WC',
    defaultPlaceholder: '0',
  },
  {
    id: 'garage',
    name: 'garage',
    labelId: 'DreamHomePageForm.DesignBriefFormFields.homeSpecification.garageLabel',
    placeholderId: 'DreamHomePageForm.DesignBriefFormFields.homeSpecification.garagePlaceholder',
    defaultLabel: 'Garage',
    defaultPlaceholder: '0',
  },
];

export const plotDetails = [
  { name: 'identifiedPlot', label: 'Have you identified a plot?' },
  { name: 'plotStage', label: 'What stage are you at with your plot?' },
  { name: 'singleHomePlot', label: 'Is your home for a single plot?' },
  { name: 'plotAddress', label: 'Plot address' },
  { name: 'siteHistory', label: 'Site history' },
  { name: 'siteGradient', label: 'Gradient of the site' },
  { name: 'planningPermissionObtained', label: 'Is the planning permission obtained?' },
  { name: 'planningPermission', label: 'Planning permission file' },
  { name: 'moodboardMediaFiles', label: 'Moodboard media files' },
  { name: 'planningPermissionMedia', label: 'Planning permission file' },
  { name: 'localPlanningAuthority', label: 'Local Planning Authority' },
  {
    name: 'mortgageDecision',
    label: 'Do you have a self build mortgage decision in principle?',
  },
  { name: 'projectBudget', label: 'Project Budget' },
  { name: 'moveInDate', label: 'When would you like to move in?' },
  { name: 'completionDate', label: 'When would you like to complete the development?' },
  { name: 'onsiteStartDate', label: 'When would you ideally like to start onsite?' },
];

export const designBriefDetails = [
  { name: 'houseType', label: 'House type' },
  { name: 'overallSiteDesignBrief', label: 'Overall site design breif' },
  { name: 'preferredConstruction', label: 'Preferred method of construction' },
  { name: 'locationArea', label: 'Location area' },
  { name: 'floorArea', label: 'Floor area' },
  { name: 'bedroomDoubleEnSuite', label: 'Bedroom double with en-suite' },
  { name: 'bedroomDouble', label: 'Bedroom double' },
  { name: 'bedroomSingle', label: 'Bedroom single' },
  { name: 'kitchen', label: 'Kitchen' },
  { name: 'diningArea', label: 'Dining area/room' },
  { name: 'livingRoom', label: 'Living room' },
  { name: 'studyOffice', label: 'Study/Office' },
  { name: 'utilityRoom', label: 'Utility room' },
  { name: 'bathroom', label: 'Bathroom' },
  { name: 'wc', label: 'Cloakroom/WC' },
  { name: 'garage', label: 'Garage' },
  { name: 'sustainabilityRequirements', label: 'Sustainability requirements' },
  { name: 'furtherInformation', label: 'Further information' },
];

export const furtherRequirementsDetails = [
  { name: 'furtherRequirements', label: 'Further requirements' },
  { name: 'perfectMethodOfConstruction', label: 'Perfect Method of Construction' },
  { name: 'professionalServices', label: 'Professional Services Required' },
];

export const moodboardCompletionOptions = [
  { key: 'yes', label: 'Yes - save and complete form' },
  { key: 'no', label: 'No - save and return to the listings page' },
];
export const documentManagementSections = [
  { name: 'projectBriefMoodBoard', title: 'Project Brief / Mood Board' },
  { name: 'planningPermissionDocs', title: 'Planning Permission Documents' },
  { name: 'buildingRegulationDocs', title: 'Building Regulations Designs' },
  { name: 'structuralDesigns', title: 'Structural Designs' },
  { name: 'finishesDesigns', title: 'Finishes Designs' },
  { name: 'budgetDocuments', title: 'Budget Documents' },
  { name: 'sitePictures', title: 'Site Pictures / Progress Updates' },
];

export const documentManagementSectionsForZip = values => {
  return [
    'projectBriefMoodBoard',
    'planningPermissionDocs',
    'buildingRegulationDocs',
    'structuralDesigns',
    'finishesDesigns',
    'budgetDocuments',
    'sitePictures',
  ].map(sectionName => ({
    name: sectionName,
    files: values[sectionName] || [],
  }));
};

export const stagesConfig = [
  { number: 1, title: 'Foundations' },
  { number: 2, title: 'Building Structure' },
  { number: 3, title: 'Wind & Water Tight' },
  { number: 4, title: 'First Fix & Plastering' },
  { number: 5, title: 'Second Fix/Certified Completion' },
];

export const stageItems = {
  1: [
    // {
    //   key: 'siteGroundPreparations',
    //   label: 'Site/ground preparations / foundations',
    //   criteriaId: 'siteGroundPreparations',
    // },
    {
      key: 'superstructureUpToDPC',
      label: 'Superstructure up to DPC',
      criteriaId: 'superstructureUpToDPC',
    },
    {
      key: 'undergroundDrainage',
      label: 'Underground drainage & utility groundworks',
      criteriaId: 'undergroundDrainage',
    },
    { key: 'groundFloorSlab', label: 'Ground floor slab' },
    {
      key: 'allowanceSlopingSite',
      label: 'Allowance for sloping site',
      criteriaId: 'allowanceSlopingSite',
    },
    { key: 'specialGroundConditions', label: 'Special ground conditions' },
  ],
  2: [
    {
      key: 'externalWallStructure',
      label: 'External wall structure',
      criteriaId: 'externalWallStructure',
    },
    {
      key: 'externalRoofStructure',
      label: 'External roof structure',
      criteriaId: 'externalRoofStructure',
    },
    {
      key: 'additionalInsulation',
      label: 'Additional insulation',
      criteriaId: 'additionalInsulation',
    },
    {
      key: 'internalWallsExcludingPlaster',
      label: 'Internal walls structure (Excluding plasterboard)',
    },
    { key: 'installationIncludingDrainage', label: 'Installation including drainage' },
    { key: 'scaffolding', label: 'Scaffolding' },
    { key: 'deliveryCost', label: 'Delivery cost' },
    { key: 'siteManagement', label: 'Site management' },
    { key: 'factoryDesignFees', label: 'Factory design fees' },
    { key: 'subsistence', label: 'Subsistence' },
  ],

  // Stage 3: Wind & Water Tight
  3: [
    { key: 'roofCoveringsExcFinishes', label: 'Roof coverings (exc. finishes)' },
    { key: 'windowsAndGlazing', label: 'Windows and glazing' },
    { key: 'externalDoors', label: 'External doors' },
  ],

  // Stage 4: First Fix & Plastering
  4: [
    { key: 'externalCladding', label: 'External Cladding (if required)' },
    { key: 'externalRendering', label: 'External rendering (if required)' },
    { key: 'roofFinishes', label: 'Roof finishes' },
    { key: 'firstFixJoinery', label: 'First fix joinery (internal walls)' },
    { key: 'firstFixElectrics', label: 'First fix electrics' },
    { key: 'firstFixPlumbing', label: 'First fix plumbing' },
    {
      key: 'mvhFirstFix',
      label: 'Mechanical ventilation and heating first fix',
    },
    { key: 'plasterBoard', label: 'Plaster board' },
    { key: 'plastering', label: 'Plastering' },
    { key: 'generalTrade', label: 'General trade' },
  ],

  // Stage 5: Second Fix / Certified Completion
  5: [
    { key: 'decoration', label: 'Decoration' },
    {
      key: 'secondFixJoinery',
      label: 'Second fix joinery (internal doors, skirting etc.)',
    },
    {
      key: 'secondFixMechanicalElectrical',
      label: 'Second fix mechanical & electrical',
    },
    { key: 'floorFinishes', label: 'Floor finishes' },
    {
      key: 'primaryKitchen',
      label: 'Kitchen (inc fittings and fixtures)',
    },
    {
      key: 'kitchenFixturesFittings',
      label: '+ Additional kitchens and utility',
    },

    {
      key: 'utilityRoomFixturesFittings',
      label: 'Utility room (inc fixtures and fittings)',
    },
    {
      key: 'bathroomFixturesFittings',
      label: 'Bathroom (inc fittings and fixtures)',
    },
    { key: 'addAdditionalBathrooms', label: '+ Additional Bathrooms' },

    // Utility connections
    { key: 'utilityConnectionGas', label: 'Gas' },
    { key: 'utilityConnectionElectric', label: 'Electric' },
    { key: 'utilityConnectionWater', label: 'Water' },
    {
      key: 'utilityConnectionUndergroundDrainage',
      label: 'Underground drainage',
    },
    { key: 'utilityConnectionBroadband', label: 'Broadband' },

    // Renewables
    { key: 'renewableSolarPanels', label: 'Solar panels' },
    {
      key: 'renewableGroundSourceHeatPumps',
      label: 'Ground Source Heat Pumps',
    },
    {
      key: 'renewableAirSourceHeatPumps',
      label: 'Air Source Heat Pumps',
    },

    // External works
    { key: 'hardLandscaping', label: 'External works: hard landscaping' },
    { key: 'softLandscaping', label: 'External works: soft landscaping' },
  ],
};

export const professionalFeesConfig = [
  {
    key: 'projectManagement',
    label: 'Project Management',
    criteriaId: 'considerProjectManager', // will render criteria text below
  },
  {
    key: 'architectDesigner',
    label: 'Architect / Designer',
    criteriaId: 'fullDesignBrief',
  },
  {
    key: 'civilEngineer',
    label: 'Civil Engineer (setting out coordinates)',
  },
  { key: 'structuralEngineer', label: 'Structural Engineer' },
  { key: 'planningConsultant', label: 'Planning Consultant' },
  { key: 'environmentalConsultant', label: 'Environmental Consultant' },
  { key: 'arboriculturalConsultant', label: 'Arboricultural Consultant' },
  { key: 'acousticConsultant', label: 'Acoustic Consultant' },
  { key: 'energySapAssessor', label: 'Energy SAP assessor & EPC' },
  { key: 'partyWallSurveyor', label: 'Party Wall Surveyor' },
  { key: 'cdmDesigner', label: 'CDM Principle Designer' },
  {
    key: 'planningSubmissionFees',
    label: 'Planning Submission Fees',
    criteriaId: 'planningSubmissionFees',
  },
  { key: 'structWarrantyFees', label: 'Building Structural Warranty Fees' },
  {
    key: 'regulationsFees',
    label: 'Building Regulations fees',
    criteriaId: 'regulationsFees',
  },
  { key: 'siteInsurance', label: 'Site Insurance' },
  { key: 'preliminaries', label: 'Preliminaries' },
  { key: 'financeBrokerageFees', label: 'Finance Brokerage fees' },
  { key: 'valuationReportFees', label: 'Valuation report fees' },
  { key: 'vatRefundSpecialist', label: 'VAT refund specialist' },
];
